import { EventType, type AuthenticationResult, type IPublicClientApplication } from '@azure/msal-browser'

/**
 * Mantiene la cuenta activa de una instancia de MSAL: la que las pantallas leen con
 * `getActiveAccount()` (el correo de la barra, «no puedes revocar tu propio acceso» en Usuarios).
 *
 * MSAL no la fija solo al volver de Entra: `handleRedirectPromise` —que corre `MsalProvider`, con
 * la aplicación ya montada— guarda la cuenta en el caché y deja la activa en null. main.tsx la
 * fijaba antes de montar con lo que hubiera en el caché, y eso solo sirve al recargar: justo
 * después de iniciar sesión el caché estaba vacío, y la barra salía sin usuario hasta el F5
 * (visto en la consola de plataforma el 17/10/2026; a la SPA de despachos le pasaba igual).
 *
 * Se registra antes de montar: así corre antes que el aviso con que `MsalProvider` repinta, y la
 * pantalla que se monta al entrar ya encuentra la cuenta activa.
 */
export function mantenerCuentaActiva(instancia: IPublicClientApplication) {
  const cuentas = instancia.getAllAccounts()
  if (cuentas.length > 0) instancia.setActiveAccount(cuentas[0])

  instancia.addEventCallback((evento) => {
    if (evento.eventType !== EventType.LOGIN_SUCCESS && evento.eventType !== EventType.ACQUIRE_TOKEN_SUCCESS) return
    const cuenta = (evento.payload as AuthenticationResult | null)?.account
    if (cuenta) instancia.setActiveAccount(cuenta)
  })
}
